"use client";

import { useEffect } from 'react';
import { TopBar, TopNavBar, Footer } from '@/layout';
import Hero from './components/Hero';
import ContactCards from './components/ContactCards';
import ContactForm from './components/ContactForm';
import ContactPartnerForm from './components/ContactPartnerForm';
import ContactOfficeCard from './components/ContactOfficeCard';
import Help from '@/views/excursions/Detail/components/Help';
import { useContactPage } from '@/hooks/useContactPage';
import { Container, Row, Col, Spinner } from 'react-bootstrap';

const sectionComponentMap = {
  hero: Hero,
  contact_cards: ContactCards,
  contact_form_customer: ContactForm,
  contact_form_partners: ContactPartnerForm
};

const Contact = ({ initialSections = null }) => {
  const { sections, loading, error } = useContactPage(null, initialSections);
  const partnerSection = sections.find((section) => section.section_key === 'contact_form_partners') || null;

  useEffect(() => {
    if (loading) return;
    const hash = typeof window !== 'undefined' ? window.location.hash.replace('#', '') : '';
    if (!hash) return;
    const el = document.getElementById(hash);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, [loading, sections]);

  if (loading) {
    return (
      <>
        <TopBar />
        <TopNavBar />
        <main>
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  if (error) {
    return (
      <>
        <TopBar />
        <TopNavBar />
        <main>
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
            <p className="text-danger">Error loading contact page: {error}</p>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <TopBar />
      <TopNavBar />
      <main>
        {sections
          .filter((section) => section.is_active)
          .sort((a, b) => {
            const orderA = a.display_order ?? 999;
            const orderB = b.display_order ?? 999;
            if (orderA !== orderB) {
              return orderA - orderB;
            }
            return (a.id ?? 0) - (b.id ?? 0);
          })
          .map((section) => {
            const Component = sectionComponentMap[section.section_key];
            if (!Component) return null;
            return <Component key={section.id || section.section_key} sectionData={section} />;
          })}
        <section className="py-4 py-lg-5">
          <Container>
            <Row className="g-4 contact-support-grid align-items-stretch">
              <Col lg={6}>
                <Help />
              </Col>
              <Col lg={6}>
                <ContactOfficeCard sectionData={partnerSection} />
              </Col>
            </Row>
          </Container>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Contact;

